module.exports = __webpack_public_path__ + "static/media/flowerPiece.017d52fe.png";